import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/layouts/main.layout'
import IndexPage from '@/pages/home/index'
import VideoPage from '@/pages/video/video.page'
import AboutPage from '@/pages/about/about.page'
// import MemberPage from '@/pages/member/member.page'
// import MemberPage from '@/pages/allmembers/allmembers'
import RecruitPage from '@/pages/recruit/recruit.page'
import RecruitEnPage from '@/pages/recruit/recruit_en.page'
import RecruitGwcPage from '@/pages/recruit/recruitgwc_en.page'
import FormPage from '@/pages/form/form.page'
import RegistrationPage from '@/pages/registration/registration.page'
import RecommendPage from '@/pages/registration/tj.page'
import VoteResultPage from '@/pages/vote/vote.page'
import coursePage from '@/pages/course/course'
import InformationPage from '@/pages/informationform/informationform'
import KctsPage from '@/pages/about/kcts'
import BirthdayPage from '@/pages/birthday/birthday'

Vue.use(Router)

export default new Router({
  mode: 'history',
  savaScrollPosition: false,
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main,
      children: [
        {
          path: '/',
          name: 'index',
          component: IndexPage
        },
        {
          path: '/video/:videoId',
          name: 'video',
          component: VideoPage
        },
        {
          path: '/about/:id/',
          name: 'about',
          component: AboutPage
        },
        // {
        //   path: '/member',
        //   name: 'member',
        //   component: MemberPage
        // },
        {
          path: '/recruit',
          name: 'recruit',
          component: RecruitPage
        },
        {
          path: '/course',
          name: 'course',
          component: coursePage
        },
        {
          path: '/kcts',
          name: 'kcts',
          component: KctsPage
        }
      ]
    },
    {
      path: '/form',
      name: 'form',
      component: FormPage
    },
    {
      path: '/recruiten',
      name: 'recruiten',
      component: RecruitEnPage
    },
    {
      path: '/gwcrecruit',
      name: 'gwcrecruit',
      component: RecruitGwcPage
    },
    {
      path: '/registration',
      name: 'registration',
      component: RegistrationPage
    },
    {
      path: '/recommend',
      name: 'recommend',
      component: RecommendPage
    },
    {
      path: '/voteadmin',
      name: 'vote',
      component: VoteResultPage
    },
    {
      path: '/information',
      name: 'information',
      component: InformationPage
    },
    {
      path: '/birthday',
      name: 'birthday',
      component: BirthdayPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js